<template>
  <div class="goodsSync">
    <div class="importMes">说明:<span>一键同步</span>即将商户所有商品同步至门店无需勾选，<span>批量同步</span>需要勾选所需同步的商品</div>
    <search-form-template
      ref="goodsSync"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      @clear="searchClear"
      @searchSubmit="searchSubmit"
      @btnCommon="btnCommon"
    ></search-form-template>

    <el-table
      class="list"
      v-loading="loading"
      header-row-class-name="table-header"
      :ref="tableOptions.tableName"
      :data="tableData"
      @selection-change="handleSelectionChange"
      :header-row-style="{height:'28px',lineHeight:'28px'}"
      @row-click="rowClick"
      row-key="id"
      @select="rowSelect"
      @select-all="rowSelect"
    >
      <!--多选-->
      <el-table-column v-if="isSelect" type="selection" width="55"></el-table-column>
      <!--索引-->
      <el-table-column
        align="center"
        type="index"
        width="60"
        label="序号"
      ></el-table-column>
      <el-table-column
        v-for="(column,index) in (tableOptions.columns)"
        :key="index"
        :class-name="column.class"
        :property="column.prop"
        :label="column.label"
        :align="column.align ||tableOptions.align"
        :min-width="column.width || tableOptions.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-show="scope.$index < tableData.length" :style="{height:'40px',lineHeight:'40px'}">
            <span v-if="column.type =='index'">{{ scope.$index + 1 }}</span>
            <el-input-number v-else-if="column.type == columnType.inputNumber"
                             @change="valueChange(column,scope.row,scope.$index)" :precision="column.precision||null"
                             v-model="scope.row[column.prop]" :min=0
                             :disabled="tableOptions.disabled"></el-input-number>
            <div v-else-if="column.enumData" v-html="$utils.getEnumItem(column,scope.row[column.prop])"></div>
            <span
              v-else-if="column.deal"
              v-html="column.deal(scope.row,column)"
              @click="itemClick(column,scope.row)"
            ></span>
            <span v-else>{{ scope.row[column.prop] }}</span>
          </div>
          <div v-show="scope.$index == tableData.length">
            {{ scope.row[column.prop] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box" style="padding-top:10px">
      <div class="fl total-cue">所有记录</div>
      <div class="fl total-cue">{{ page.total }}条</div>
      <!--分页-->
      <el-pagination
        class="tr"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-size="page.pageSize"
        :page-sizes="[10, 15, 20, 30, 40]"
        layout="prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
    <div
      v-loading.fullscreen.lock="onloading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.3)"
    >
    </div>
  </div>
</template>

<script>
  import searchFormTemplate from '../template/searchFormTemplate';
  import tableTemplate from '../template/tableTemplate';
  import api from '@/config/api';

  export default {
    components: {tableTemplate, searchFormTemplate},
    props: {
      isSelect: {
        type: Boolean,
        default: () => {
          return false;
        }
      },

      tableOptions: {
        type: Object,
        default: () => {
          return {
            tableName: "goodsTable",
            stripe: false, //是否斑马纹
            border: false, //是否带边框
            height: 500, //表格高度 单位px
            fixed: false, //string, boolean  true, left, right true 表示固定在左侧 表格左侧或右侧一列固定
            showSelect: false, // 是否显示选择框
            template: "", //自定义列模板 传入模板名称
            indexShow: false, //是否显示索引
            indexMethod: this.getIndex,
            columns: [
              {label: "ID", prop: "id", width: "100"},
              {label: "名称", prop: "name", width: "100"}
            ],
            url: "",
            param: {}
          };
        }
      },
    },
    data() {
      return {
        tableRow: {},
        columnType: this.$utils.columnType,
        onloading:false,
        loading: false,
        searchParam: {},
        tabelSelectRows: [],
        tableData: [],
        searchOptions: {
          simple: [
            {
              label: '目标门店',
              prop: 'storeId',
              type: 'select',
              data: [],
              url: api.store.store,
              disabled: false
            },
            {
              label: '源门店',
              prop: 'syncStoreId',
              type: 'select',
              data: [],
              // url: api.store.storeList,
              isHasAll:true,
              url: api.system.seStore,
              change: this.syncStoreChange
            },
            {
              label: '品牌',
              prop: 'goodsBrandId',
              type: 'select',
              data: [],
              url: api.archives.brand,
            },
            {
              label: '供应商',
              prop: 'supplierId',
              type: 'select',
              data: [],
              url: api.archives.supplier
            },
            {
              label: '类别',
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              valueKey: 'value',
              data: [],
              span: 12,
              change: this.typeChange,
              url: api.archives.getCategoryTree,
            },
            {
              label: '条码/名称',
              prop: 'otherName',
              type: 'input',
              placeholder:'条码/名称模糊搜索'
            },
          ]
        },
        toolConfig: [
          {
            label: '一键同步',
            code: 'insert',
            callback: this.getSync
          },
          {
            label: '批量同步',
            code: 'batchModifying',
            callback: this.batchSync
          },
        ],
        page: {
          current: 1,
          total: 0,
          pageSize: 10
        },
        params: {},

      }
    },
    created() {
      this.getNewData();
      // this.getTableData();
      this.initData();
      this.storeChange();
    },
    methods: {
      //点击数据
      itemClick(column, value) {
        column.callback && column.callback(value);
      },
      //如果是门店登录的时候目标门店是不可编辑的
      storeChange() {
        let user = this.$utils.getSysUser();
        if (user.storeId) {
          this.searchOptions.simple.filter(item => item.prop === 'storeId')[0].disabled = true;
          this.$nextTick(() => {
            this.$refs['goodsSync'].formModel.storeId = user.storeId;
          })
        }
      },
      syncStoreChange(row) {
        let param = this.$refs['goodsSync'].getSimpleParams();
        console.log(row);
        //选择源门店的时候不能和目标门店相同
        if (row.storeId === row.syncStoreId) {
          this.$message({message: '目标门店和源门店不能相同!', type: 'warning'});
        } else {
          //选择了源门店之后才能获取相关数据
          this.getTableData();
        }
      },
      //获取数据
      getTableData() {
        let searchParam = {
          pageNumber: this.page.current,
          pageSize: this.page.pageSize
        };
        Object.assign(searchParam, this.tableOptions.param || {});
        //Object.assign(searchParam, this.searchParam);
        console.log(this.$refs['goodsSync'])
        let param = this.$refs['goodsSync'].getSimpleParams();
        // if (param.goodsCategoryIds.length < 1) {
        //   param.goodsCategoryIds = null;
        // }
        Object.assign(searchParam, param);
        if (param.syncStoreId === undefined) {
          this.$message({message: "源门店不能为空!", type: "warning"});
        } else {
          if (param.storeId === undefined) {
            this.$message({message: "目标门店不能为空!", type: "warning"});
          } else {
            if (searchParam.syncStoreId < 0) {
              searchParam.syncStoreId = null;
            }
            console.log(searchParam);
            this.loading = true;
            this.$axios.fetchPost(this.tableOptions.url + "/page", searchParam)
              .then(data => {
                this.loading = false;
                if (data.code === 200 && data.data) {
                  this.tableData = data.data.records;
                  this.tableData.map(item => {
                    item.inventoryNum = 0.00.toFixed(2);
                  });
                  this.page.total = data.data.total;
                } else {
                  this.$message({message: "请求失败！", type: "error"});
                }
              })
              .catch(err => {
                console.log(err);
                this.$message({message: "请求失败！", type: "error"});
                this.loading = false;
              });
          }
        }
      },
      //翻页
      handleCurrentChange(value) {
        this.page.current = value;
        this.getTableData();
      },
      //选中项
      handleSelectionChange(val) {
        this.selectRow = val;
      },
      handleSizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.page.current = 1;
        this.getTableData();
      },
      //清除选中
      clearSelection() {
        this.$refs[this.tableOptions.tableName].clearSelection();
      },

      searchClear() {
        // this.$refs.goodsSync.simpleClear()
        this.searchParam = {};
        this.getTableData({});
      },
      //查询
      searchSubmit(param) {
        this.tableOptions.param = param;
        this.getTableData();
        //this.$refs['goodsSync'].formModel.otherName = '';
      },
      rowClick(row, column, event) {
        if (this.isSelect) return;
        this.$emit('rowCheck', row);
      },
      //一键同步
      getSync() {
        if (this.tableData.length === 0) {
          this.$message({message: '没有数据可一键同步！', type: 'info'});
        } else {
          let param = this.$refs['goodsSync'].getSimpleParams();
          if (param.syncStoreId === undefined) {
            this.$message({message: "源门店不能为空!", type: "warning"});
          } else {
            if (param.storeId === undefined) {
              this.$message({message: "目标门店不能为空!", type: "warning"});
            } else {
              if (param.syncStoreId < 0) {
                param.syncStoreId = null;
              }
              this.onloading = true
              this.$axios.fetchPost("/api/eros/as/asGoods/goods/syn", {
                synType: 20,
                storeId: param.storeId,
                syncStoreId: param.syncStoreId,
                goodsBrandId: param.goodsBrandId,
                supplierId: param.supplierId,
                goodsCategoryIds: param.goodsCategoryIds
              }).then(data => {
                this.onloading = false
                if (data.code === 200) {
                  this.getTableData();
                  this.$message({message: '商品一键同步成功！', type: 'success'});
                  this.getNewData()
                }else{
                  this.$message({message: '商品一键同步失败！'+data.code, type: 'error'});
                }
              })
            }
          }
        }
      },
      //批量同步
      batchSync() {
        if (this.tabelSelectRows.length === 0) {
          this.$message({message: '请勾选您要同步的商品！', type: 'info'});
        } else {
          let param = this.$refs['goodsSync'].getSimpleParams();
          if (param.syncStoreId === undefined) {
            this.$message({message: "源门店不能为空!", type: "warning"});
          } else {
            if (param.storeId === undefined) {
              this.$message({message: "目标门店不能为空!", type: "warning"});
            } else {
              if (param.syncStoreId < 0) {
                param.syncStoreId = null;
              }
              this.onloading = true
              this.$axios.fetchPost("/api/eros/as/asGoods/goods/syn", {
                synType: 10,
                storeId: param.storeId,
                syncStoreId: param.syncStoreId,
                goodsBrandId: param.goodsBrandId,
                supplierId: param.supplierId,
                goodsCategoryIds: param.goodsCategoryIds,
                goodsMVOList: this.tabelSelectRows
              }).then(data => {
                this.onloading = false
                if (data.code === 200) {
                  this.getTableData();
                  this.$message({message: '商品批量同步成功！', type: 'success'});
                  this.tabelSelectRows = []
                  this.getNewData()
                }else{
                  this.$message({message: '商品一键同步失败！'+data.code, type: 'error'});
                }
              })
            }
          }
        }
      },
      rowSelect(selection) {
        this.tabelSelectRows = selection;
      },

      initData() {
        this.tableOptions.columns.map(column => {
          if (column.prop)
            this.tableRow[column.prop] = '';
          if (column.type == 'inputNumber')
            this.tableRow[column.prop] = undefined;
        });
        this.$set(this.tableData, 0, this.tableRow);
      },
      valueChange(column, row, index) {
        this.$forceUpdate();
        column.change && column.change(row, index);
      },
      btnCommon(btnObj) {
        btnObj.callback && btnObj.callback();
      },
      getNewData() {
        this.$parent.$parent.$refs.goodsInfo.operationSuccess()
      }
    },

  }
</script>

<style scoped>
  .goodsSync {
    height: 480px;
    margin-bottom: 20px;
  }

  .importMes {
    margin-left: 10px;
    color: red;
    margin-bottom: 10px;
    width: 48%;
  }

  .importMes span {
    color: blue;
  }
  >>>.form-item-wrapper{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/business/goodsSync.vue